import axios from 'axios';
import urlConfig from "@/../public/urlConfig.json"
import jwtDecode from "jwt-decode";
import vue from "vue";

var apiUrl = '';
fetch(process.env.BASE_URL + "urlConfig.json")
    .then((response) => response.json())
    .then((config) => {
        apiUrl = config.authenticationBaseAddress;
    })


// const apiUrl = (vue.prototype.$config.authenticationBaseAddress);

export default {

    state: {
        user: {},
        isAuthenticated: false,
        userId: "",
        username: "",
        expires_in: 0,
        menuItemStatus: false,
    },
    mutations: {
        SetUsername(state, username) {
            state.username = username;
        },
        SetUserId(state, userId) {
            state.userId = userId;
        },
        SetUserAuthenticated(state, isAuth) {
            state.isAuthenticated = isAuth;
        },
        SetMenuItemStatus(state, item) {
            state.menuItemStatus = item;
        }
    },

    getters: {
        GetUsername(state) {
            return state.username
        },
        GetUserId(state) {
            return state.userId
        },
        IsUserAuthenticated(state) {
            return state.isAuthenticated;
        },
        GetRefreshToken(state) {
            return state.refreshToken
        },
        GetMenuItemStatus(state) {
            return state.menuItemStatus;
        }
    },
    actions: {
        async checkProfileUpdatedPass(context, params) {

            try {
                const response = await axios.post(apiUrl + "Authentication/checkProfileUpdatedPass", params);

                return response.data.data;
            } catch (err) {
                console.log(err);
            }
        },

        async createProfileAndIndividual(context, data) {

            try {
                const response = await axios.post(apiUrl + "Authentication/CreateProfileAndIndividualAsync", data);

                if (response.status == 200) {
                    return response;
                }
                throw response.error;

            } catch (err) {
                console.log(err);
            }
        },

        async login(context, params) {

            try {
                const response = await axios.post(apiUrl + "Authentication/login", params);

                if (response.status === 200 && response.data.data.errorCode !== 12) {
                    var decoded = jwtDecode(response.data.data.access_token);

                    context.commit("SetUserAuthenticated", true);
                    context.commit("SetUserId", decoded.sub);
                    context.commit("SetUsername", decoded.name);

                    localStorage.setItem('Access_Token', response.data.data.access_token);
                    localStorage.setItem('Refresh_Token', response.data.data.refresh_token);
                    localStorage.setItem("UserId", decoded.sub);
                    localStorage.setItem("Username", decoded.given_name + " " + decoded.family_name);
                    localStorage.setItem("Email", params.username);
                    localStorage.setItem("expires_in", response.data.data.expires_in);
                    localStorage.setItem("IsAuthenticated", true);

                    const isArray = Array.isArray(decoded.role);
                    if (isArray)

                        localStorage.setItem("UserRoles", JSON.stringify(decoded.role));
                    else {
                        const lstRole = []
                        lstRole.push(decoded.role)
                        localStorage.setItem("UserRoles", JSON.stringify(lstRole));
                    }

                    return response;
                }
                else
                    return response

            } catch (err) {
                console.log(err);
            }
        },

        async checkForLogin(context, dispatch) {
            try {

                if (localStorage.getItem("Access_Token")) {
                    context.commit("SetUserAuthenticated", true);
                    context.commit("SetUserId", localStorage.getItem("UserId"));
                    context.commit("SetUsername", localStorage.getItem("Username"));

                    //  await context.dispatch("startRefreshTokenInterval");
                }

            } catch (err) {
                console.log(err);
            }
        },
        async signOut(context) {
            try {
                context.commit("SetUserAuthenticated", false);
                context.commit("SetMenuItemStatus", false);
                localStorage.clear();

            } catch (err) {
                console.log(err);
            }
        },

        async register(context, data) {
            // debugger
            try {
                const response = await axios.post(apiUrl + "authentication/register", data);

                if (response.status == 200) {
                    return response;
                }
                throw response.error;

            } catch (err) {
                console.log(err);
            }
        },
        async updateProfileStatus(context, data) {

            try {
                const response = await axios.post(apiUrl + "authentication/updateProfileStatus", data);

                if (response.status == 200) {
                    return response;
                }
                throw response.error;

            } catch (err) {
                console.log(err);
            }
        },
        async updateIsUpdatedPassword(context, data) {

            try {
                const response = await axios.post(apiUrl + "authentication/updateIsUpdatedPassword", data);

                if (response.status == 200) {
                    return response;
                }
                throw response.error;

            } catch (err) {
                console.log(err);
            }
        },
        changeMenuItemStatus(context, data) {
            context.commit("SetMenuItemStatus", data)
        }
    },
};
